

























import { mdiCloseCircle, mdiCheckboxMarkedCircle } from '@mdi/js';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  data() {
    return {
      mdiCloseCircle,
      mdiCheckboxMarkedCircle
    };
  }
})
export default class Status extends Vue {
  @Prop(String) typeStatus!: string;
  @Prop(String) statusName!: string;
  @Prop(String) statusDesc!: string;
  @Prop(Number) statusPercent!: number;
  @Prop(Boolean) canBeSurcharge!: boolean;
  @Prop(String) surchargeId!: string;


  get getColor() {
    switch (this.typeStatus) {
      case 'error':
        return 'red';
      case 'success':
        return 'green';
      case 'waiting':
        return 'primary';
      default:
        return '';
    }
  }
}
